import { DraggableModalWrapper } from '@/shared/ui';
import EcgBookmarkTime from './ecgBookmarkTime';
import useHRSummaryModal from './useHRSummaryModal';

/**
 * Hosts the draggable modals belonging to the HR summary tab. Reads the control-modal flags, timezone and ECG data map from useHRSummaryModal and shows the add-ECG-bookmark time picker while its flag is set.
 *
 * @returns The rendered draggable modal wrapper for the ECG bookmark form.
 */
const HRSummaryModal = () => {
  const { controlModal, timezone, ecgDataMap } = useHRSummaryModal();

  return (
    <>
      {/* Add ecg bookmark */}
      <DraggableModalWrapper
        visible={controlModal.isShowAddEcgBookmark}
        ariaLabel="Add ECG bookmark"
      >
        <EcgBookmarkTime timezone={timezone} ecgDataMap={ecgDataMap} />
      </DraggableModalWrapper>
      {/* Add ecg bookmark */}
    </>
  );
};

export default HRSummaryModal;
